<template>
  <div class="connection-info relative" v-if="isDisconnected || isConnecting">
    <div
      class="absolute top-0 text-center w-full z-10 text-gray-700 py-1 px-2 text-xs"
      :class="[
        isConnecting && 'bg-yellow-400',
        isDisconnected && 'bg-red-200',
        !isConnecting && !isDisconnected && 'bg-gray-200',
      ]"
    >
      <div v-if="isDisconnected">
        {{ t("messengerConnectionStatus.disconnectedMessage") }}
      </div>
      <div v-else-if="isConnecting">
        {{ t("messengerConnectionStatus.reconnectingMessage") }}
      </div>
      <!--      <div v-else>Successfully connected</div>-->
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import { useOnline } from "@vueuse/core";
import { useChatConnection } from "../composables/chatConnection";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "MessengerConnectionStatus",
  components: {},
  setup() {
    const { status } = useChatConnection();
    const isOnline = useOnline();
    const { t } = useI18n();

    const isConnecting = computed(() => status.value === "CONNECTING");

    const isDisconnected = computed(
      () => status.value === "CLOSED" || !isOnline.value
    );

    return {
      isConnecting,
      isDisconnected,
      t,
    };
  },
});
</script>

<style scoped lang="scss">
@import "@/assets/animation.scss";

.powered-by {
  @include animation(0, 1s, fade-in);
}
</style>
